import Section from '@/components/Section';
import styles from './index.module.scss';

export interface TechPoint {
  title: string;
  description: string;
  icon: string;
}

export interface TechSectionProps {
  titleLines: string[];
  subTitle: string;
  points: TechPoint[];
  background?: string;
}

export default function TechSection({
  titleLines,
  subTitle,
  points,
  background,
}: TechSectionProps) {
  return (
    <Section background={background} className={styles.section}>
      <div className={styles.layout}>
        <div className={styles.left}>
          <div className={styles.titleWrap}>
            {titleLines.map((line) => (
              <span key={line} className={styles.titleLine}>
                {line}
              </span>
            ))}
          </div>
          <p className={styles.subTitle}>{subTitle}</p>
        </div>
        <div className={styles.right}>
          {points.map((point) => (
            <div key={point.title} className={styles.point}>
              <span className={styles.icon}>
                <img src={point.icon} alt={point.title} loading="lazy" />
              </span>
              <div className={styles.pointText}>
                <h3 className={styles.pointTitle}>{point.title}</h3>
                <p className={styles.pointDesc}>{point.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
